<template>
  <v-container fluid class="bi-control-panel-page d-flex flex-column align-stretch">
    <v-col cols="12" class="d-flex pa-0 justify-start bi-control-panel-title">
      <span span class="base-title"> Painel de Controle do BI </span>
    </v-col>
    <v-tabs v-model="tab" colors="primary" background-color="transparent">
      <v-tab v-for="tab in tabs" :key="tab.id">
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="bi-control-panel-tabs-items">
      <v-tab-item
        v-for="tabItem in tabs"
        :key="tabItem.id"
        class="bi-control-panel-tab-item"
      >
        <BIParametersTab v-if="tabItem.id === 'BIParameters'" :can-edit="canEditParameters" />
        <BIApprovalTab v-if="tabItem.id === 'BIApproval'" :can-edit="canEditApproval" />
      </v-tab-item>
    </v-tabs-items>

    <v-footer class="bi-control-panel-footer transparent pa-0">
      <v-row class="d-flex justify-end ma-0">
        <v-btn
          outlined
          color="primary"
          width="180px"
          height="36"
          @click="onClickBack"
        >
          {{ $t('common.back') }}
        </v-btn>
      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import BIParametersTab from '@/views/biControlPanel/BIParametersTab.vue';
import BIApprovalTab from '@/views/biControlPanel/BIApprovalTab.vue';
import i18n from '@/plugins/i18n';

export default {
  name: 'BIControlPanel',
  components: { BIParametersTab, BIApprovalTab },
  mixins: [AuthorityManagementMixin],
  data() { return { tab: null }; },
  computed: {
    tabs() {
      const allTabs = [
        {
          id: 'BIParameters',
          name: i18n.t('biControlPanel.tabs.biParamaters'),
          viewAuthority: 'bi_control_panel_parameters_view',
        },
        {
          id: 'BIApproval',
          name: i18n.t('biControlPanel.tabs.biApproval'),
          viewAuthority: 'bi_control_panel_approval_view',
        },
      ];
      return allTabs.filter((tab) => this.hasPermission(tab.viewAuthority));
    },
    canEditParameters() {
      return this.hasPermission('bi_control_panel_parameters_edit');
    },
    canEditApproval() {
      return this.hasPermission('bi_control_panel_approval_edit');
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'HomeAllMenus' });
    },
  },
};
</script>

<style lang="scss">
.bi-control-panel-page {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  padding: 30px 40px 20px;

  .bi-control-panel-title {
    flex: 0 0 auto;
    padding-bottom: 30px !important;
  }

  > .v-tabs {
    flex: 0 0 auto;
  }

  .bi-control-panel-tabs-items {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;

    > .v-window__container,
    .bi-control-panel-tab-item {
      height: 100%;
      min-height: 0;
    }
  }

  .bi-control-panel-footer {
    flex: 0 0 auto;
    padding-right: 20px !important;
    padding-top: 16px !important;
  }
}
</style>
